/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TargetLabel.vue?vue&type=template&id=4669836e&scoped=true&"
import script from "./TargetLabel.vue?vue&type=script&lang=js&"
export * from "./TargetLabel.vue?vue&type=script&lang=js&"
import style0 from "./TargetLabel.vue?vue&type=style&index=0&id=4669836e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4669836e",
  null
  
)

export default component.exports